// * Components
import Navbar from "./Navbar";
import CustomButton from "./CustomButton";

// * Images
import IconLogo from "../assets/images/logos/icononly_transparent_nobuffer.png";

// * MUI Components
import { Box, Container, Typography, styled } from "@mui/material";

// * MUI Icons

// * Styled Components
const CustomHeroBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  gap: theme.spacing(5),
  marginTop: theme.spacing(3),
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "64px",
  color: "#2B3674",
  fontWeight: "bold",
  margin: theme.spacing(4, 0, 4, 0),
  [theme.breakpoints.down("sm")]: {
    fontSize: "40px",
  },
}));

export default function Hero() {
  return (
    <Box
      sx={{
        background: "transparent",
        minHeight: "60vh",
        paddingBottom: 2,
        marginBottom: 6,
      }}
    >
      <Container>
        <Navbar />

        <CustomHeroBox>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="body2"
              sx={{
                fontSize: "18px",
                color: "#3370FF",
                fontWeight: "600",
                mt: 10,
                mb: 4,
              }}
            >
              Financial Automation for Everyone
            </Typography>
            <Title variant="h2">
              Automate Your Money. Effortlessly.
            </Title>
            <Typography
              variant="body2"
              sx={{ fontSize: "18px", color: "#2B3674", my: 4, lineHeight: 1.8 }}
            >
              Dizpurse lets you create rules that move your money automatically—save more, pay down debt faster, and stay on top of your finances.
            </Typography>
            <Box
              sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}
              onClick={() => {
                document.getElementById('waitlist')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              <CustomButton
                backgroundColor="#3370FF"
                color="#fff"
                buttonText="Join the Waitlist"
                heroBtn={true}
              />
            </Box>
          </Box>

          <Box sx={{ flex: 0.8, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <img
              src={IconLogo}
              alt="Dizpurse - Automate Your Money"
              style={{ maxWidth: "75%", filter: "drop-shadow(0px 10px 30px rgba(51, 112, 255, 0.2))" }}
            />
          </Box>
        </CustomHeroBox>
      </Container>
    </Box>
  );
}
